import type { AppEnv } from '../types/app-env'

export const getAppEnv = () =>
	(process.env.NEXT_PUBLIC_APP_ENV as AppEnv) ?? 'prod'
